module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-10-a993435402e939cf1a40cbd800a80165.svg";